import { useDataState } from "../../hooks/useData";

export function useVerificationData(){
    const [verificationData, setVerificationData] = useDataState('verificationData')
    return {
        verificationData,
        setVerificationData
    }
}